import React from "react"
import Feature2 from "./Features/Feature2"

function ProjectPreview(props) {

  return (
    <div class="container" id={props.id}>
      <div class="row align-items-center">
        <div class="col-12 col-md-7 col-lg-6" data-aos="fade-right">

          {/* Heading */}
          <h2>
          <a href={props.url}><span class="text-primary">{props.title}</span></a><br/>{props.title2}.
            </h2>

          {/* Text */}
          <p class="font-size-lg text-muted mb-6">{props.description}</p>

          {/* List */}
          {props.features.map( feature => (
            <Feature2 iconpath={"./assets/img/icons/duotone-icons/" + feature.iconpath} title={feature.title} description={feature.description}/>
          ))}
        </div>
        <div class="col-12 col-md-5 col-lg-6">

          <div class="w-md-150 w-lg-130 position-relative" data-aos="fade-left">

            {/* Image */}
            <div class="img img-left">
              <img src={props.src} class="img-fluid img-skewed-item" alt="..."/>
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default ProjectPreview
